function getNumCompare(){ return  $(".compare-remove-item").length;}  
$(function () {
    
      $('.hotel-search-map-view-2').on("click",function () {
        alert('show full screen map with compare hotels')
        return false;
      });


    $('.close-compare').on("click",function () {
        window.removeEventListener('resize',resizeCompare);
        $(".compare-holder").hide()
        $("#header-wrap,#footer").show();
        $("body").css('overflow','unset');
       
        return false;
    });
  
      $(document).on('click', ".compare-trigger-btn", function (e) {
          if (getNumCompare()<2){
              alert('Please select 2 or more properties to compare.')
          }else{
            $(".compare-holder").show()
            $("#header-wrap,#footer").hide();
            $("body").css('overflow','hidden');
            window.addEventListener('resize', resizeCompare);  
            resizeCompare()
            getCompareList();
         }
          return false;
      });

       $(document).on('click', ".compare-clear", function (e) {             
          console.log("compare clear click")
          updatecompareItem(-1,false);
          return false;
      });

      
     
      $(document).on('click', ".jq-hotel-compare", function (e) {
          
        console.log("jq-hotel-compare click")
        var e=  $(this).find("i")
        var key=$(this).data("compare-key");
          
          if (e.hasClass("bi-bookmark-fill")){
            
            console.log('remove prop from compare')
            var find="[data-placekey='" + key + "']";
            var bk=$(".compare-remove-item"+find);
            if(bk.length>0){
                $(".compare-slide").addClass("open").show( 100, "easeOutSine");
                $(bk).trigger("click")
                return false;
            }
     
        }else{
            if ($(".compare-blank").length==0){ 
                alert('You can only select 5 properties to compare.')
            }else{                      
                console.log('add prop to compare')
                //var sHTML ="<div class=\"col-1\"><div class=\"rounded compare-item\" title=\"" + $(this).data("compare-title") + "\" style=\"background-image: url('" + $(this).data("compare-img") + "');\"><div class=\"compare-remove-item text-center\" data-placekey=" + $(this).data("compare-key") + ">X</div></div></div>";
                //$(".compare-blank").first().parents(".col-1").html(sHTML).removeClass(".compare-blank");
                updatecompareItem( key,false);
            }
            $(".compare-slide").addClass("open").show( 100, "easeOutSine");
        }
        //initCompareState()
        return false;
      });

    $('.compare-trigger button').on("click", function () {
        $(".compare-slide").toggleClass("open", 100, "easeOutSine");
        return false;
    });

     $(document).on('click', ".compare-list-remove-item", function (e) {
        console.log('remove prop from compare results')
         var n=$(".compare-results-items table tr:first td").length;
         if (n==1){ alert('The last compare property cannot be removed'); return false;}
         var key=$(this).data("remove-placekey");
        updatecompareItem("-" +  key,true);
        return false;
    });
    

      $(document).on('click', ".compare-remove-item", function (e) {
        //$(this).parents(".col-1").html("<div class=\"rounded compare-item compare-blank\"></div>");         
        console.log('remove prop from compare 2')
        updatecompareItem("-" +  $(this).data("placekey"),false);
        //initCompareState()
        return false;
    });

       initCompareState();

  });

  function getCompareList(){
      var DTO = {};
       DynaProxy.invoke("GetCompareListing", DTO, function(data) {$(".jq-compare-results").html(data);}, AjaxFailed)
  }
  function resizeCompare(){
    //console.log('resizeCompare')
    var boundingRef = document.querySelectorAll('.compare-title')[0].getBoundingClientRect();
    var nHeight=window.innerHeight-boundingRef.height;
    $(".compare-results").css('height',  nHeight + 'px');
}

 function updatecompareItem(n,fromlist){
        var DTO = {'placekey': n};
        DynaProxy.invoke("UpdateCompareItem", DTO, function(data) {
        $(".compare-details-items").html(data);
        initCompareState();
        if (fromlist){getCompareList();}
        }, AjaxFailed)
}
function initCompareState(){
    //update compare count
    console.log("initCompareState")
    var items=getNumCompare();
    $(".compare-item-count").html(items);

    //show based on number in compare
    if (items>0){ $(".compare-slide").show();   }else{$(".compare-slide").hide();}

    //set state of any compare icons on page
    //uncheck them all
    $(".jq-hotel-compare").removeClass("active")
    $(".jq-hotel-compare i").removeClass("bi-bookmark-fill").addClass("bi-bookmark")

    //make active any in compare
     $(".compare-remove-item").map(function (i, obj) {
        var key=$(this).data("placekey");
        var find="[data-compare-key='" + key + "']";
        var bk=$(".jq-hotel-compare"+find);
        if(bk.length>0){
            var e=  bk.find("i");
            e.addClass("bi-bookmark-fill").removeClass("bi-bookmark");
            bk.addClass("active");
        }
    });
}